import React from "react";
import { useParams, Navigate } from "react-router-dom";
import RevealRoot from "@/components/landing/RevealRoot";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import Comparison from "@/components/landing/Comparison";
import AnimatedDemo from "@/components/landing/AnimatedDemo";
import WhoFor from "@/components/landing/WhoFor";
import {
  ToolHero,
  ThreeCards,
  SplitTwo,
  BeforeAfter,
  SourceLogos,
  CardGrid,
  AccessBand,
  UpsellBand,
  WaitlistBand,
  PricingBand,
  FinalCTABand,
} from "@/components/tool/Sections";
import { TOOL_PAGES } from "@/config/toolPages";
import SEO from "@/components/SEO";

export default function Tool() {
  const { slug } = useParams();
  const cfg = TOOL_PAGES[slug];

  // Set the document title (per-page) — must be called unconditionally before early return
  React.useEffect(() => {
    if (cfg) document.title = `JobHacki — ${cfg.title}`;
  }, [cfg]);

  if (!cfg) return <Navigate to="/" replace />;

  return (
    <div
      data-testid="tool-page"
      data-slug={slug}
      className="bg-[#FDFBF7] text-[#0a0a0a] min-h-screen"
    >
      <RevealRoot>
        <SEO
          title={`JobHacki — ${cfg.title}`}
          description={cfg.hero?.sub}
          canonical={`https://jobhacki.com/${slug}`}
        />
        <Navbar />
        <ToolHero {...cfg.hero} />
        {cfg.sections.map((s, i) => {
          const key = `${slug}-${i}`;
          switch (s.type) {
            case "threeCards":
              return <ThreeCards key={key} {...s} />;
            case "splitTwo":
              return <SplitTwo key={key} {...s} />;
            case "beforeAfter":
              return <BeforeAfter key={key} />;
            case "sourceLogos":
              return <SourceLogos key={key} />;
            case "liveDemo":
              return <AnimatedDemo key={key} />;
            case "comparison":
              return <Comparison key={key} />;
            case "whoFor":
              return <WhoFor key={key} />;
            case "cardGrid":
              return <CardGrid key={key} {...s} />;
            case "accessBand":
              return <AccessBand key={key} {...s} />;
            case "upsellBand":
              return <UpsellBand key={key} {...s} />;
            case "waitlistBand":
              return <WaitlistBand key={key} {...s} />;
            case "pricingBand":
              return <PricingBand key={key} {...s} />;
            case "finalCta":
              return <FinalCTABand key={key} {...s} />;
            default:
              return null;
          }
        })}
        <Footer />
      </RevealRoot>
    </div>
  );
}
